module.exports = __webpack_public_path__ + "fonts/NanumSquareRoundEB.ef40431.ttf";